export interface GrampsEventMedia {
  file: string
  handle?: string
  grampsId?: string
}

export interface GrampsNote {
  "@handle": string
  "@id": string
  "@change": string
  text: string
}

export const frenchEvents = {
    'Birth': 'naissance',
    'Death': 'décès',
    'Christening': 'baptème',
    'Baptism': 'baptème',
    'Occupation': 'profession',
    'Marriage': 'mariage',
    'Residence': 'résidence',
    'Military Service': "fait militaire",
    'Award': 'distinction',
    'Marriage Banns': 'publication des bans',
    'Census': 'recensement',
    "Degree": "diplôme",
    "Will": "testament",
    "Burial": "sépulture",
    "Exodus": "exode",
    "Naturalization": "naturalisation",
    "Divorce": "divorce",
    "Marriage Contract": "contrat de mariage",
    "Misc": "divers",
    "Nobility Title": "titre de noblesse",
}

export function lcFirst(string: string|undefined): string {
  if (string === undefined || string.length === 0) {
    return string ?? '';
  }

  return string[0].toLowerCase() + string.slice(1)
}
